export enum PermissionRole {
  Manager = 'manager',
  Receptionist = 'user',
}
